import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { io } from 'socket.io-client';
import config from '../../app/config';
import { getSessionToken } from '../../app/utils';
import { setClient, setClientReady } from '../../features/aiBotSlice';

export default function SocketioLayer() {
  const dispatch = useDispatch();
  const { orgId, id } = useParams();
  const { client } = useSelector(store => store.aiBot);

  const sessionToken = getSessionToken();

  useEffect(() => {
    if (id && orgId && sessionToken && !client) {
      const socketClient = io(config.AIBOT_SOCKET_SERVER_URL, {
        forceNew: true,
        path: '/aibot_setting/',
        auth: {
          orgId,
          aiBotId: id,
          sessionToken,
        },
        transports: ['websocket'],
        autoConnect: false,
      });

      socketClient.on('ready', token => {
        socketClient.token = token;
        dispatch(setClientReady(true));
      });
      socketClient.on('disconnect', () => {
        dispatch(setClientReady(false));

        // eslint-disable-next-line no-console
        console.warn('aibot socket disconnect!!');
      });

      socketClient.io.on('reconnect', () => {
        // eslint-disable-next-line no-console
        console.warn('aibot socket reconnect!!');
      });

      socketClient.connect();
      dispatch(setClient(socketClient));
    }

    return () => {
      if (id && orgId && sessionToken && client) {
        client.off();
        client.io.off();
        dispatch(setClient(null));
        dispatch(setClientReady(false));
      }
    };
  }, [id, orgId, sessionToken, client]);

  return <></>;
}
